import u from "lodash/isPlainObject";
import r from "lodash/isDate";
import { datesAreEqual as i, pageForDate as d, getMaxPage as f, addPages as h } from "../helpers.js";
import m, { addDays as o } from "../date-info.js";
class T {
  constructor({ locale: t, format: e, parse: a }) {
    Object.assign(this, { locale: t, format: e, parse: a });
  }
  hasValue(t) {
    return u(t) && r(t.start) && r(t.end);
  }
  normalize(t) {
    if (!this.hasValue(t))
      return null;
    const { start: e, end: a } = new m(
      {
        start: new Date(t.start),
        end: new Date(t.end)
      },
      {
        locale: this.locale
      }
    );
    return { start: e, end: a };
  }
  formatValue(t) {
    const e = this.normalize(t);
    if (!e)
      return "";
    const { start: a, end: n } = e, s = this.format(a), l = this.format(n);
    return !s || !l ? "" : `${s} - ${l}`;
  }
  parseValue(t) {
    let e, a;
    const n = t.split("-").map((s) => s.trim());
    return n.length >= 2 && (e = this.parse(n[0]), a = this.parse(n[1])), e && a ? this.normalize({ start: e, end: a }) : null;
  }
  filterDisabled({ value: t, isRequired: e, disabled: a, fallbackValue: n }) {
    let s = e ? n : null;
    return this.hasValue(t) && (!a || !a.intersectsDate(t)) && (s = t), s;
  }
  valuesAreEqual(t, e) {
    const a = this.hasValue(t), n = this.hasValue(e);
    return !a && !n ? !0 : a !== n ? !1 : i(t.start, e.start) && i(t.end, e.end);
  }
  getPageRange(t) {
    if (!this.hasValue(t))
      return null;
    const e = d(t.start), a = f(d(t.end), h(e, 1));
    return {
      from: e,
      to: a
    };
  }
  parseShortcutValue(t) {
    return r(t.start) && r(t.end) ? this.normalize(t) : this.normalize({
      start: o(/* @__PURE__ */ new Date(), t.start),
      end: o(/* @__PURE__ */ new Date(), t.end)
    });
  }
  handleDayClick(t, e) {
    const { dateTime: a } = t;
    if (e.dragValue) {
      const n = this.normalize({
        start: new Date(e.dragValue.start.getTime()),
        end: new Date(a)
      });
      e.dateIsValid(n) && (e.dragValue = null, e.model = n, e.$emit("select-date", { value: n }));
    } else {
      const n = {
        start: new Date(a),
        end: new Date(a)
      };
      e.dateIsValid(n) && (e.dragValue = n);
    }
  }
  handleShortcutSelect(t, e) {
    e.dateIsValid(t.value) && (e.dragValue = null, e.model = t.value);
  }
  handleDayMouseEnter(t, e) {
    const { dateTime: a } = t;
    if (e.dragValue) {
      const n = {
        start: new Date(e.dragValue.start.getTime()),
        end: new Date(a)
      };
      e.dateIsValid(n) && (e.dragValue = n);
    }
  }
}
export {
  T as default
};
//# sourceMappingURL=range.js.map
